import axios from 'axios';

import { Toast } from 'vant';

const request = axios.create({
  timeout: 60000,
});
// 允许出现多个Toast
Toast.allowMultiple();
// 请求拦截器
request.interceptors.request.use(config => {
  Toast.loading({
    duration: 0,
    forbidClick: true,
  });
  config.headers.post['Content-Type'] = 'application/json';
  console.log(config);
  return config;
}, error => {
  return Promise.reject(error);
})


// 请求返回拦截器
request.interceptors.response.use(response => {
  const res = response.data;
  const { status } = res;
  console.log(response);
  if (status === 200) {
    // 清除loading toast
    Toast.clear()
    return Promise.resolve(res);
  }
  
  Toast.clear()
  Toast.fail('操作失败');
  return Promise.reject(res);
}, error => {
  Toast.clear()
  Toast.fail('操作失败');
  return error
})

export default request;